// extracted by mini-css-extract-plugin
export var quillEditor = "_o6-1";
export var variable = "_o6-0";